import {
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { getCFDIListV2, getCFDIPreviewV2 } from '../../services/invoice.service';
const listQueryKey = 'cfdi';
const previewQueryKey = 'cfdi-preview';

interface IQueryFnParams {
  data: any[];
  page: number;
  total_pages: number;
  total_results: number;
}

export const useGetCFDIs = (enabled: boolean, query: {
  query?: string;
  storeId?: string;
  fromDate?: string;
  toDate?: string;
  limit?: string;
}) => useInfiniteQuery<IQueryFnParams>({
  staleTime: 0,
  enabled: enabled,
  queryKey: [
    listQueryKey,
    query.query,
    query.storeId,
    query.fromDate,
    query.toDate,
    query.limit,
  ],
  initialPageParam: 1,
  getNextPageParam: (lastPage) => {
    if (lastPage.page === lastPage.total_pages) {
      return undefined
    }
    return lastPage.page + 1;
  },
  getPreviousPageParam: (firstPage, allPages, firstPageParam) => {
    if ((firstPageParam as number) <= 1) {
      return undefined
    }
    return (firstPageParam as number) - 1
  },
  queryFn: async ({ queryKey, pageParam }: { queryKey: any, pageParam: string }) => {
    try {
      const [_key] = queryKey;
      const res = await getCFDIListV2({
        ...query,
        limit: query.limit,
        pageNum: pageParam
      });

      if (!res?.data?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data as IQueryFnParams;
    } catch (e: any) {
      backendErrorsHandler(e);
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});



export const useGetCFDIPreviewV2 = (params: {
  ordersID?: string[];
  customer?: string
}, enabled: boolean) => useQuery<any>({
  queryKey: [previewQueryKey, { ordersID: params.ordersID, customer: params.customer }],
  enabled: enabled,
  retry: false,
  queryFn: async () => {
    try {
      const res = await getCFDIPreviewV2(params);
      if (!res?.data?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      backendErrorsHandler(e);
      throw e;
    }
  }
});
